module.exports = __webpack_public_path__ + "static/img/img17.ff7f4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img17.jpg
// module id = ho/w
// module chunks = 1